import { useNavigate } from "react-router";
import { Card } from "../SharedComponents/Layout/Card";
import { Icons } from "../SharedComponents/Icons/Icons";
import { RecapEntriesViewModel } from "../../../ViewModel/RecapEntriesViewModel";
import { SimpleTextViewModel } from "../../../ViewModel";
import React from "react";


interface RecapCardProps {
    entry: RecapEntriesViewModel;
    className?: string;
}

export function RecapSummaryCard({ entry, className }: RecapCardProps) {

    const navigate = useNavigate();

    const [accomplishment] = React.useState(entry.selectedAccomplishments.values[
        Math.floor(Math.random() * entry.selectedAccomplishments.values.length)
    ]);
    const [magicMoment] = React.useState(entry.selectedMagicMoments.values[
        Math.floor(Math.random() * entry.selectedMagicMoments.values.length)
    ]);

    const DataRow = ({ icon, text }: { icon: React.ReactNode, text: SimpleTextViewModel[] }) => {


        var pickOne = text[Math.floor(Math.random() * text.length)];

        return (
            < div className="flex flex-row mb-100" >
                {icon}
                < div className="flex flex-column align-items-start justify-content-center" >
                    <p
                        className="gl-reacp-card-item gl-text-entry-typography m-0 text-overflow-ellipsis"
                        key={pickOne.Data?.key}
                        style={{ lineClamp: 2, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
                    >{pickOne.TypedData.text}</p>
                </div >
            </div >
        );
    };

    return (
        <Card className={`gl-recap-card border-round-2xl flex-none w-10 ml-125 mr-125 ${className ?? ''}`}>
            <div
                className="flex flex-column justify-content-around text-sm text-left pt-75 pb-75 v-full"
                onClick={() => navigate(`/journal/recap/${entry.Data!.key}`)}>
                <h4 className="gl-recap-summary-header text-left mt-0">{entry.RecapsSectionCardHeader}</h4>
                {
                    accomplishment &&
                    <DataRow
                        icon={<Icons.BlueRibbon className="flex-none" />}
                        text={[accomplishment]} />
                }
                {
                    magicMoment &&
                    <DataRow
                        icon={<Icons.Star className="flex-none" />}
                        text={[magicMoment]} />
                }
            </div>
        </Card>

    );
}